"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messages = void 0;
const intl_1 = require("@kyruus/intl");
exports.messages = (0, intl_1.defineMessages)({
    newPatientLabel: {
        id: 'availability.new_patient',
        description: 'Text for labelling that the patient relationship is new',
        defaultMessage: 'New'
    },
    establishedPatientLabel: {
        id: 'availability.established_patient',
        description: 'Text for labelling that the patient relationship is established',
        defaultMessage: 'Established'
    },
    patientRelationshipLabel: {
        id: 'availability.patient_relationship',
        description: 'Label for the patient relationship buttons',
        defaultMessage: 'Patient Type'
    },
    appointmentPurposeLabel: {
        id: 'availability.appointment_purpose',
        description: 'Label for the appointment purpose dropdown',
        defaultMessage: 'Appointment Type'
    },
    locationLabel: {
        id: 'availability.location',
        description: 'Label for the appointment location dropdown',
        defaultMessage: 'Location'
    },
    allLocationsLabel: {
        id: 'availability.location.all',
        description: 'Label for the appointment location dropdown all locations option',
        defaultMessage: 'All Locations'
    },
    visitMethodLabel: {
        id: 'availability.visit_method',
        description: 'Label for the visit method buttons',
        defaultMessage: 'Visit Method'
    },
    appointmentPurposePlaceholder: {
        id: 'availability.appointment_purpose.placeholder',
        description: 'Placeholder for the appointment purpose dropdown',
        defaultMessage: 'Select an appointment type'
    },
    locationPlaceholder: {
        id: 'availability.location.placeholder',
        description: 'Placeholder for the appointment location dropdown',
        defaultMessage: 'All locations'
    },
    locationSelection: {
        id: 'availability.location.selection',
        description: 'Label for the selected appointment location',
        defaultMessage: '{name} • {street1} {street2}'
    },
    visitTypeInPerson: {
        id: 'availability.visit_method.inPerson',
        description: 'Text to be displayed for a related purpose option',
        defaultMessage: 'In Person Visit'
    },
    visitTypeVideo: {
        id: 'availability.visit_method.video',
        description: 'Text to be displayed for a related purpose option',
        defaultMessage: 'Video Visit'
    },
    visitTypePhone: {
        id: 'availability.visit_method.phone',
        description: 'Text to be displayed for a related purpose option',
        defaultMessage: 'Phone Visit'
    },
    visitGroupInPerson: {
        id: 'availability.visit_group.inPerson',
        description: 'Text to be displayed for the in person purpose group',
        defaultMessage: 'In Person'
    },
    visitGroupVirtual: {
        id: 'availability.visit_group.virtual',
        description: 'Text to be displayed for the virtual purpose group',
        defaultMessage: 'Virtual'
    },
    disabledPatientRelationshipWarning: {
        id: 'availability.disabled_patient_relationship_warning',
        description: 'Text to be displayed when a patient relationship option is disabled',
        defaultMessage: 'No online appointments available for {relationship} patients, call to schedule.'
    },
    newPatientWarningBannerLabel: {
        id: 'availability.new_patient_warning_banner_label',
        description: 'Text for warning banner labelling that the patient relationship is new',
        defaultMessage: 'New'
    },
    establishedPatientWarningBannerLabel: {
        id: 'availability.established_patient_warning_banner_label',
        description: 'Text for warning banner labelling that the patient relationship is established',
        defaultMessage: 'Established'
    },
    providerAvailabilityDaySlotsAriaLabel: {
        id: 'availability.slotsAriaLabel',
        description: 'Accessibility text to be read by screen reader for provider availablity slots with a date',
        defaultMessage: '{date} and {time} with {providerName} at {locationName}'
    },
    providerAvailabilityTimeSlotsAriaLabel: {
        id: 'availability.timeSlotsAriaLabel',
        description: 'Accessibility text to be read by screen reader for provider availablity with only time',
        defaultMessage: '{time} with {providerName} at {locationName}'
    },
    noAppointmentsAvailable: {
        id: 'availability.no_appointments_available',
        description: 'Text to display when no slots are returned for any locations',
        defaultMessage: 'No appointments available'
    },
    nextAvailability: {
        id: 'availability.next_availability',
        description: 'Text to display before next date with availability',
        defaultMessage: 'Next availability: {date}'
    }
});
//# sourceMappingURL=messages.js.map